<template>
  <v-app style='background: url("https://www.toptal.com/designers/subtlepatterns/patterns/white-waves.png")'>
    <v-app-bar
      app
      flat
    >
      <v-toolbar-title>
        <p class="ont-weight-black">Portfolio</p></v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn class="ma-2" tile text color="success">
      <v-icon left>mdi-android-studio</v-icon> Apps
    </v-btn>

    <v-btn class="ma-2" text color="success">
      <v-icon left>mdi-nodejs</v-icon> Web
    </v-btn>

    </v-app-bar>

    <v-content>
      <v-container>
        <v-row><!--lg="2" offset-lg="1"-->
            <v-col xs="12" offset-xs="0" sm="8" offset-sm="2" md="3" offset-md="0" class="mt-7"  xl="3" offset-xl="0"  >
              <div :class="{ 'pa-6' : $vuetify.breakpoint.smAndDown }">
              <p class="display-1 font-weight-bold ma-0">Kateti Mareko</p>
              <p>Developer</p>
              <div class="text-left">
                <v-chip
                pill
                class="mr-3"
                          href="https://www.linkedin.com/in/kateti-mareko-ba274541"
                          target="_blank"
                >
                  <v-avatar left
                          size="40">
                            <img src="https://image.flaticon.com/icons/svg/1384/1384014.svg">
                          </v-avatar>
                          Linkedin
                </v-chip>
                <v-chip
                pill
                href="https://github.com/Codenert"
                          target="_blank"

                >
                  <v-avatar left
                          size="30">
                          <img src="https://image.flaticon.com/icons/svg/25/25231.svg">
                          </v-avatar>
                          Github
                </v-chip>
                
              </div>
              <br/>
              <p>Passionate
                about creating software, websites and apps that provide solutions to real world challenges. 
              </p>
              <p>
                Built and managed apps and website for Kiribati community needs.
              </p>
              <br>
              </div>
            </v-col>
            <v-col xs="12" offset-xs="0" sm="8" offset-sm="2" md="9" offset-md="0"> <!--lg="6" offset-lg="1"-->
              <Home/>
            </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Home from './components/Home';

export default {
  name: 'App',

  components: {
    Home,
  },

  data: () => ({
    skills: [
      "Android",
      "Git",
      "Kotlin",
      "VueJs",
      "Vuetify",
      "Java",
      "NodeJs",
      "Express",
      "Html5",
      "Css3",
      "JQuery",
      "Bootstrap3",
      "Javascript",
      "Asp.Net Core 2",
      "C#"
    ]
    //
  }),
};
</script>

<style>

</style>
